module.exports = __webpack_public_path__ + "img/diagram_21_1.13495064.png";